import { RemoveSectionsRegistrationAttributesCommand } from '../../../registration_attributes/commands/remove_section_registration_attributes_command';
import { ClearTransientAccessCredCommand } from '../../../prevent_transient_access/commands/clear_transient_access_cred_command';
import { TransientAccessCredEventNames } from '../../../prevent_transient_access/constants/transient_access_cred_constants';
import { PreventTransientAccessQuery } from '../../../prevent_transient_access/queries/prevent_transient_access_query';
import { HILForm } from '../../../interfaces/scheduler_interfaces';
import { RegistrationAttributesServant } from '../../../registration_attributes/servants/registration_attributes_servant';
import { WaitlistSectionCommand } from '../../../views/unscheduled_sections/commands/waitlist_section_command';
import { CourseSchedulerConstant } from '../../../views/course_scheduler/constants/course_scheduler_constants';
import { SubmitRegAttrFormAndGetOutputCommand } from '../../../registration_attributes/commands/submit_reg_attr_form_and_get_output_command';
import { SectionRegistrationAttributesQuery } from '../../../registration_attributes/queries/section_registration_attributes_query';
import { LoadSectionRegistrationAttributesCommand } from '../../../registration_attributes/commands/load_section_registration_attributes_command';
import { StoreRegistrationAttributeValuesCommand } from '../../../registration_attributes/commands/store_registration_attribute_values_command';
import * as _4 from 'lodash4';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ICommand } from 'core-ts-types';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { SectionDetailsQuery } from '../../section_details/queries/section_details_query';
import { SchedulerCustomTextQuery } from '../../../views/course_scheduler/queries/scheduler_custom_text_query';

class SectionActionWaitListPromptCtrl {
  private openPrompt: boolean = false;
  private section: ISection;
  private isPermissionPinsFeatureEnabled = false;
  private sectionPins = {};
  private openBound = this.openWaitlistPrompt.bind(this);
  private closeBound = this.closeDialog.bind(this);
  private addToWaitlistBound = this.addToWaitlist.bind(this);

  constructor(
    private $state: ng.ui.IStateService,
    private waitlistSectionCommand: WaitlistSectionCommand,
    private $stateParams: ng.ui.IStateParamsService,
    private saveTermPinCommand: ICommand,
    private updateSeatAvailabilityCommand: ICommand,
    private $timeout: ng.ITimeoutService,
    private ngCourseSchedulerConstant: typeof CourseSchedulerConstant,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSectionDetailsQuery: SectionDetailsQuery,
    private ngSectionRegistrationAttributesQuery: SectionRegistrationAttributesQuery,
    private storeRegistrationAttributeValuesCommand: StoreRegistrationAttributeValuesCommand,
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand,
    private submitRegAttrFormAndGetOutputCommand: SubmitRegAttrFormAndGetOutputCommand,
    private removeSectionsRegistrationAttributesCommand: RemoveSectionsRegistrationAttributesCommand,
    private loadSectionRegistrationAttributesCommand: LoadSectionRegistrationAttributesCommand,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private appConfigModel: any
  ) {}

  $onInit() {
    this.isPermissionPinsFeatureEnabled = this.appConfigModel.model.member_features['reg-class_permission'];
    this.ngComponentCommunicatorService.subscribe('OPEN_WAITLIST_PROMPT', this.openBound);
    this.ngComponentCommunicatorService.subscribe('CLOSE_WAITLIST_PROMPT', this.closeBound);
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release('OPEN_WAITLIST_PROMPT', this.openBound);
    this.ngComponentCommunicatorService.release('CLOSE_WAITLIST_PROMPT', this.closeBound);
  }

  openWaitlistPrompt() {
    this.updateProperties();

    this.storeRegistrationAttributeValuesCommand()
      .then(() => this.loadSectionRegistrationAttributesCommand(this.section.id))
      .then(() => {
        this.openPrompt = true;
        this.ngComponentCommunicatorService.subscribe(
          TransientAccessCredEventNames.NEW_CRED_SAVED,
          this.addToWaitlistBound
        );

        this.ngComponentCommunicatorService.subscribe(
          TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
          this.closeBound
        );
      });
  }

  updateProperties() {
    this.section = this.ngSectionDetailsQuery.result.section;
  }
  closeDialog() {
    this.openPrompt = false;
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, this.addToWaitlistBound);
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeBound
    );
  }
  openedChanged($event: any) {
    if ($event && $event.detail && !$event.detail.value) {
      this.closeDialog();
    }
  }

  onPinValueChanged(event: any) {
    const pin = event.detail.value;
    this.sectionPins[this.section.id] = pin;
  }

  addToWaitlist() {
    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      return this.submitRegAttrForm().then(() =>
        this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS)
      );
    }

    return this.saveTermPinCommand(this.$stateParams.termId).then(() => {
      this.performWaitlistAction();
    });
  }

  submitRegAttrForm() {
    const formElement = document.querySelector(
      `#${CourseSchedulerConstant.waitListConfirmationSectionFormId}`
    ) as HILForm;
    return this.submitRegAttrFormAndGetOutputCommand(
      formElement,
      CourseSchedulerConstant.waitListConfirmationSectionFormId,
      [this.section.id]
    );
  }

  performWaitlistAction() {
    this.submitRegAttrForm()
      .then((formOutput) => {
        this.closeDialog();
        return this.waitlistSectionCommand(
          [this.section.id],
          this.sectionPins,
          formOutput,
          this.ngPreventTransientAccessQuery.result.output
        ).then(() => {
          if (
            this.$state.is('my.schedule.registration.unscheduledCourseInfo') ||
            this.$state.is('my.schedule.registration.courseSections')
          ) {
            this.$state.go('^');
          }
          return this.updateSeatAvailabilityCommand([this.section.id]);
        });
      })
      .catch(() => {
        // switch step tabs without filling the reg attr and initiate the waitlist action from auth cred form
        // this catch means the reg attr form output doesn't exist.
        if (this.ngPreventTransientAccessQuery.result.workflowEnabled) {
          this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
        }
        const formRenderingDelay = 500;
        this.$timeout(() => {
          this.submitRegAttrForm();
        }, formRenderingDelay);
      })
      .finally(() => {
        this.clearTransientAccessCredCommand();
      });
  }
}

angular.module('capability-ng-scheduler').component('sectionActionWaitListPrompt', {
  controller: SectionActionWaitListPromptCtrl,
  templateUrl:
    'capability-ng-scheduler/src/components/section_action_button/section_action_wait_list_prompt/section_action_wait_list_prompt.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_action_button/section_action_wait_list_prompt/section_action_wait_list_prompt.ts